import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm';
import Splide from "@splidejs/splide";
import anime from "animejs";
import SmoothScroll from "smooth-scroll";
import * as ScrollMagic from "scrollmagic";

/**
 * Splide config object contains all the options that are needed
 * to initialize the hero fade effect.
 */
const splide_config = {
  type: "fade",
  perPage: 1,
  arrows: false,
  pagination: false,
  interval: 4500,
  autoplay: false,
  rewind: true,
  drag: false,
  pauseOnFocus: false,
  pauseOnHover: false,
  speed: 1400,
};

const splide_config_2 = {
  type: "fade",
  perPage: 1,
  arrows: false,
  pagination: false,
  interval: 5000,
  autoplay: true,
  rewind: true,
  drag: false,
  pauseOnFocus: false,
  pauseOnHover: false,
  speed: 2000,
};

/**
 * try catch for hero fade effect
 */
try {
  let experience_splide;
  let current_slide = 0;
  const MAX_SLIDES = document.querySelectorAll(".exp-wrapper").length;
  experience_splide = new Splide("#hero_slide", splide_config).mount();
  new Splide("#gallery_slide", splide_config_2).mount();

  document.querySelector("#exp-btn-next").addEventListener("click", () => {
    if (current_slide == MAX_SLIDES - 1) {
      current_slide = 0;
      experience_splide.go(current_slide);
    } else {
      current_slide = current_slide + 1;
      experience_splide.go(current_slide);
    }
  });
  document.querySelector("#exp-btn-prev").addEventListener("click", () => {
    if (current_slide == 0) {
      current_slide = MAX_SLIDES - 1;
      experience_splide.go(current_slide);
    } else if (current_slide != 0 && current_slide < MAX_SLIDES) {
      current_slide = current_slide - 1;
      experience_splide.go(current_slide);
    }
  });
} catch (e) {
  console.warn("Problem exporting Splide List");
}

/**
 * Website animations
 *  - Nav bar
 *  - All scroll Animations
 */
try {
  // Add scrollmagic controller
  let controller = new ScrollMagic.Controller();

  if(
    document.querySelector('.hostel-exclusive-section')
  ) {
    let text_timeline_1 = anime({
      targets: ["#string-1"],
      translateX: ["-50%", "0"],
      autoplay: false,
      easing: "linear",
    });
    let text_timeline_2 = anime({
      targets: ["#string-2"],
      translateX: ["0%", "-60%"],
      autoplay: false,
      easing: "linear",
    });
    let text_timeline_3 = anime({
      targets: ["#string-3"],
      translateX: ["0%", "-60%"],
      autoplay: false,
      easing: "linear",
    });

    new ScrollMagic.Scene({
      triggerElement: ".no-small-img-block",
      duration: 3200, // the scene should last for a scroll distance of 100px
      offset: 260, // start this scene after scrolling for 50px
    })
      .addTo(controller)
      .on("progress", (event) => {
        text_timeline_1.seek(event.progress * text_timeline_1.duration);
        text_timeline_2.seek(event.progress * text_timeline_2.duration);
        text_timeline_3.seek(event.progress * text_timeline_3.duration);
      });
  }

  /**
   *
   */
  let kasol_img_timeline = anime({
    targets: [".big-img-section"],
    translateY: ["150", "0"],
    width: ["80%","100%"],
    autoplay: false,
    easing: "easeInOutCubic",
  });

  // init controller

  // create a scene
  new ScrollMagic.Scene({
    triggerElement: ".explore-section",
    duration: 1200, // the scene should last for a scroll distance of 100px
    offset: 0, // start this scene after scrolling for 50px
  })
    .addTo(controller)
    .on("progress", (event) => {
      kasol_img_timeline.seek(event.progress * kasol_img_timeline.duration);
    });
} catch (e) {
  console.warn("Pronblem exporting AnimeJs");
}

try {
  new SmoothScroll('a[href*="#"]', {
    speed: 1600,
    speedAsDuration: true,
    easing: "easeInOutCubic",
    offset: 260,
    updateURL: false,
  });
} catch (e) {
  console.warn("Problem exporting smooth scroll");
}

try{
  document.getElementById('show-more-btn').addEventListener('click', () => {
    document.querySelector('.testimonial-section').style.height = 'auto';
    document.querySelector('.show-shadow').style.display = 'none';
    document.querySelector('#show-more-btn').style.display = 'none';
  });
} catch (e) {
  console.warn("Problem with buttons");
}

new PhotoSwipeLightbox({
  gallery: '#gallery--super-dorm',
  showHideAnimationType: 'none',

  // optionally disable zoom transition,
  // to create more consistent experience
  zoomAnimationDuration: false,
  children: 'a',
  pswpModule: () => import('photoswipe')
}).init();

new PhotoSwipeLightbox({
  gallery: '#gallery--six-dorm',
  showHideAnimationType: 'none',

  // optionally disable zoom transition,
  // to create more consistent experience
  zoomAnimationDuration: false,
  children: 'a',
  pswpModule: () => import('photoswipe')
}).init();

new PhotoSwipeLightbox({
  gallery: '#gallery--four-dorm',
  showHideAnimationType: 'none',

  // optionally disable zoom transition,
  // to create more consistent experience
  zoomAnimationDuration: false,
  children: 'a',
  pswpModule: () => import('photoswipe')
}).init();

new PhotoSwipeLightbox({
  gallery: '#gallery--delux-bed',
  showHideAnimationType: 'none',

  // optionally disable zoom transition,
  // to create more consistent experience
  zoomAnimationDuration: false,
  children: 'a',
  pswpModule: () => import('photoswipe')
}).init();

new PhotoSwipeLightbox({
  gallery: '#gallery--semi-bed',
  showHideAnimationType: 'none',

  // optionally disable zoom transition,
  // to create more consistent experience
  zoomAnimationDuration: false,
  children: 'a',
  pswpModule: () => import('photoswipe')
}).init();

new PhotoSwipeLightbox({
  gallery: '#gallery--std-bed',
  showHideAnimationType: 'none',

  // optionally disable zoom transition,
  // to create more consistent experience
  zoomAnimationDuration: false,
  children: 'a',
  pswpModule: () => import('photoswipe')
}).init();

new PhotoSwipeLightbox({
  gallery: '#gallery--delux-shared',
  showHideAnimationType: 'none',

  // optionally disable zoom transition,
  // to create more consistent experience
  zoomAnimationDuration: false,
  children: 'a',
  pswpModule: () => import('photoswipe')
}).init();

// Jibhi galleries
new PhotoSwipeLightbox({
  gallery: '#gallery--deluxe-room',
  showHideAnimationType: 'none',
  zoomAnimationDuration: false,
  children: 'a',
  pswpModule: () => import('photoswipe')
}).init();

new PhotoSwipeLightbox({
  gallery: '#gallery--duplex',
  showHideAnimationType: 'none',
  zoomAnimationDuration: false,
  children: 'a',
  pswpModule: () => import('photoswipe')
}).init();

new PhotoSwipeLightbox({
  gallery: '#gallery--cafe',
  showHideAnimationType: 'none',
  zoomAnimationDuration: false,
  children: 'a',
  pswpModule: () => import('photoswipe')
}).init();

new PhotoSwipeLightbox({
  gallery: '#gallery--reception',
  showHideAnimationType: 'none',
  zoomAnimationDuration: false,
  children: 'a',
  pswpModule: () => import('photoswipe')
}).init();

new PhotoSwipeLightbox({
  gallery: '#gallery--exterior',
  showHideAnimationType: 'none',
  zoomAnimationDuration: false,
  children: 'a',
  pswpModule: () => import('photoswipe')
}).init();

// Manali galleries
new PhotoSwipeLightbox({
  gallery: '#gallery--four-dorm-balcony',
  showHideAnimationType: 'none',
  zoomAnimationDuration: false,
  children: 'a',
  pswpModule: () => import('photoswipe')
}).init();

new PhotoSwipeLightbox({
  gallery: '#gallery--standard',
  showHideAnimationType: 'none',
  zoomAnimationDuration: false,
  children: 'a',
  pswpModule: () => import('photoswipe')
}).init();

new PhotoSwipeLightbox({
  gallery: '#gallery--king',
  showHideAnimationType: 'none',
  zoomAnimationDuration: false,
  children: 'a',
  pswpModule: () => import('photoswipe')
}).init();

new PhotoSwipeLightbox({
  gallery: '#gallery--deluxe-common',
  showHideAnimationType: 'none',
  zoomAnimationDuration: false,
  children: 'a',
  pswpModule: () => import('photoswipe')
}).init();

new PhotoSwipeLightbox({
  gallery: '#gallery--deluxe-private',
  showHideAnimationType: 'none',
  zoomAnimationDuration: false,
  children: 'a',
  pswpModule: () => import('photoswipe')
}).init();

new PhotoSwipeLightbox({
  gallery: '#gallery--common-area',
  showHideAnimationType: 'none',
  zoomAnimationDuration: false,
  children: 'a',
  pswpModule: () => import('photoswipe')
}).init();